var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
var CHECKMARK_SIZE = 18;
var wrapperStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
});
export function wrapperStyle(_a) {
    var disabled = _a.disabled, inverted = _a.inverted;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        wrapperStaticStyle,
        css({
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? tokens.opacity.high : 1,
        }),
    ], false);
}
export var inputStaticStyle = css({
    cursor: 'inherit',
    height: CHECKMARK_SIZE,
    margin: 0,
    opacity: 0,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: CHECKMARK_SIZE,
});
export var labelStaticStyle = css({
    color: theme.text.main,
    cursor: 'inherit',
    lineHeight: tokens.lineHeights.default,
    paddingLeft: tokens.spacing.small,
    paddingTop: '1px',
    userSelect: 'none',
});
var checkmarkStaticStyle = css({
    '&::after': {
        borderRadius: '6px',
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-3px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    alignItems: 'center',
    borderRadius: tokens.borderRadius.medium,
    borderStyle: 'solid',
    borderWidth: tokens.borderWidth.thin,
    color: theme.text.inverse,
    display: 'flex',
    flexShrink: 0,
    height: CHECKMARK_SIZE,
    justifyContent: 'center',
    pointerEvents: 'none',
    position: 'relative',
    transition: 'background-color 75ms ease-out, border-color 75ms ease-out',
    width: CHECKMARK_SIZE,
});
export function checkmarkStyle(_a) {
    var checked = _a.checked, hasError = _a.hasError, isFocusVisible = _a.isFocusVisible, isIndeterminate = _a.isIndeterminate;
    return [
        checkmarkStaticStyle,
        css(__assign(__assign({ backgroundColor: checked || isIndeterminate
                ? theme.blue.darker
                : theme.background.contrast, borderColor: checked || isIndeterminate
                ? theme.blue.darker
                : theme.border.interactive }, (isFocusVisible && {
            '&::after': {
                boxShadow: "0 0 0 2px ".concat(theme.border.focusOutline),
            },
        })), (hasError && {
            borderColor: theme.error.darker,
            boxShadow: "0 0 0 1px ".concat(theme.error.darker),
        }))),
    ];
}
